import {svgIconWrapper} from '../svg-icon-wrapper';

import HeadsetRegular from './headset-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HeadsetRegular {...validProps} />;
}

SvgComponent.iconName = 'headsetRegular';

export const HeadsetRegularIcon = svgIconWrapper(SvgComponent);
